'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { clickEvent } from '@marketplace-web/business-accounts/business-accounts-data'

import { BUSINESS_REGISTER_PATH } from '../../constants/routes'

const ConvertButton = (props: React.ComponentProps<typeof Button>) => {
  const { track } = useTracking()

  function handleClick() {
    track(
      clickEvent({
        target: 'convert_to_business',
        screen: 'business_homepage',
      }),
    )
  }

  return (
    <Button
      {...props}
      styling={Button.Styling.Filled}
      url={BUSINESS_REGISTER_PATH}
      onClick={handleClick}
    />
  )
}

export default ConvertButton
